package pt.at.oss.kotlin.manual.schema.common.currvatid

import pt.at.oss.kotlin.manual.storage.common.currvatid.CurrVatId
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.schema.StringSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * CurrVatIdSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class CurrVatIdSchema : RecordSchema<CurrVatId>(name = "currVatId") {

    val issuingCountrySchema: StringSchema = StringSchema(name = "issuingCountry")
    val vatIdNumSchema: StringSchema = StringSchema(name = "vatIdNum")
    override fun isValid(value: CurrVatId?): Boolean {
        return value == null || (
            issuingCountrySchema.isValid(value.issuingCountry) &&
                vatIdNumSchema.isValid(value.vatIdNum)
            )
    }

    override fun validate(value: CurrVatId?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(issuingCountrySchema.validate(value.issuingCountry, appendToPath(path, "issuingCountry")))
        validator.addErrors(vatIdNumSchema.validate(value.vatIdNum, appendToPath(path, "vatIdNum")))
        return validator
    }
}
